<div class="w-full max-w-4xl">
    <mat-drawer-container class="flex-auto h-full bg-card dark:bg-transparent">
        <mat-drawer-content class="flex flex-col">
            <div class="flex-auto">
                <div id="header"
                    class="flex flex-col sm:flex-row md:flex-col flex-auto justify-between py-8 px-6 md:px-8 border-b">
                    <div>
                        <div class="text-4xl font-extrabold tracking-tight leading-none">
                            {{ 'label_bakvordur' | translate }}
                        </div>
                        <div class="ml-0.5 font-medium text-secondary">
                            {{ 'label_bakvordur_employees_checked_in_count' | translate: { count:
                            checkedInEmployeesCount } }}
                        </div>
                    </div>

                    <div *ngIf="hasBakvordurAdminRole" class="flex items-center mt-4 sm:mt-0 md:mt-4">
                        <div class="flex-auto">
                            <mat-form-field
                                class="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded w-full min-w-50">
                                <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:search'"></mat-icon>

                                <input matInput [formControl]="searchInputControl" [autocomplete]="'off'"
                                    [placeholder]="'label_bakvordur_search_employee' | translate" />
                            </mat-form-field>

                            <div class="mt-2 ml-1 text-sm text-secondary">
                                <ng-container *ngIf="searchInputControl.value?.trim(); else totalEmployees">
                                    {{ searchedEmployees?.length ?? 0 }} af {{ employeesIn?.length ?? 0 }} starfsmönnum
                                    fundust
                                </ng-container>

                                <ng-template #totalEmployees>
                                    {{ employeesIn?.length ?? 0 }} starfsmenn í lista
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="!hasHttpFetched || !userDetails" class="flex flex-col items-center justify-center py-16">
                    <mat-progress-spinner mode="indeterminate" diameter="48">
                    </mat-progress-spinner>

                    <div class="mt-4 text-secondary">
                        {{ 'label_loading' | translate }}
                    </div>
                </div>

                <div *ngIf="hasBakvordurAdminRole" class="relative">
                    <ng-container *ngIf="hasHttpFetched && searchedEmployees?.length !== 0">
                        <ng-container *ngFor="
                                let employee of searchedEmployees;
                                trackBy: trackByBakvordurEmployeeJobId;
                                let i = index
                            ">
                            <div *ngIf="
                                    i === 0 ||
                                    employee.name.charAt(0).toUpperCase() !==
                                        searchedEmployees[i - 1].name.charAt(0).toUpperCase()
                                "
                                class="z-10 sticky top-0 -mt-px px-6 py-1 md:px-8 border-t border-b font-medium uppercase text-secondary bg-gray-50 dark:bg-gray-900">
                                {{ employee.name.charAt(0).toUpperCase() }}
                            </div>

                            <div class="z-20 flex items-center px-6 py-4 md:px-8 overflow-x-hidden border-b">
                                <div
                                    class="flex flex-0 items-center justify-center w-10 h-10 rounded-full bg-primary-100 text-primary-700 font-semibold">
                                    {{ employee.name.charAt(0).toUpperCase() }}
                                </div>

                                <div class="w-100 ml-4">
                                    <div class="font-medium leading-5 truncate">
                                        {{ employee.name }}
                                    </div>

                                    <div class="flex flex-wrap sm:flex-nowrap text-secondary">
                                        <span class="flex flex-row grow">
                                            {{ 'label_bakvordur_employee_no' | translate }}
                                            {{ employee.employeeno }}
                                        </span>

                                        <span class="hidden md:flex flex-row shrink gap-2">
                                            <div
                                                class="h-8 py-1 px-3 rounded-full leading-normal bg-green-100 text-green-700">
                                                <span class="text-sm font-medium whitespace-nowrap">
                                                    {{ 'label_bakvordur_checked_in' | translate }}
                                                </span>
                                            </div>

                                            <div
                                                class="h-8 py-1 px-3 rounded-full leading-normal bg-gray-100 flex items-center">
                                                <mat-icon class="icon-size-4 mr-1"
                                                    [svgIcon]="'heroicons_outline:clock'"></mat-icon>

                                                <span class="text-sm font-medium whitespace-nowrap">
                                                    {{ employee.punchdate | date:'HH:mm' }}
                                                </span>
                                            </div>
                                        </span>
                                    </div>

                                    <div class="mt-1 text-sm text-secondary flex items-center">
                                        <mat-icon class="icon-size-4 mr-1"
                                            [svgIcon]="'heroicons_outline:calendar'"></mat-icon>

                                        {{ employee.punchdate | date:'dd.MM.yyyy HH:mm' }}
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>

                    <div *ngIf="!isLoading && hasHttpFetched && searchedEmployees && searchedEmployees.length === 0 && hasSearched"
                        class="p-8 sm:p-16 border-t text-4xl font-semibold tracking-tight text-center">
                        {{ 'info_bakvordur_no_employee_found' | translate }}
                    </div>
                </div>
            </div>
        </mat-drawer-content>
    </mat-drawer-container>
</div>